import moment from 'moment-timezone';

export class ReportBankPaymentReconciliation {
	public agentId: string;
	public agentName: string;
	public year: number;
	public month: number;
	public pk_amount: number;
	public qbo_amount: number;
	public diff_amount: number;
	public qboVendorId: number;
	public entityRefId: number;

	public date: Date;

	constructor(reportBankPaymentReconciliation: ReportBankPaymentReconciliation) {
		Object.assign(this, reportBankPaymentReconciliation);

		this.date = moment({ year: this.year, month: this.month - 1, day: 1 }).toDate();
	}

	get monthName() {
		return moment(this.date).format('MMMM');
	}
}
